import {ASYNC_ROUTER_MAP, CONSTANT_ROUTER_MAP} from '@/router/index';

/**
 * 比对用户拥有菜单名称与路由名称
 */
function getMenu(name, menus) {
  for (let i = 0; i < menus.length; i++) {
    let menu = menus[i];
    if (name === menu.name) {
      return menu;
    }
  }
  return null;
}

/**
 * 判断是否具有访问权限
 */
function hasPermission(menus, route) {
  if (route.name) {
    let currentMenu = getMenu(route.name, menus);
    if (currentMenu != null) {
      // 设置菜单的标题、图标和可见行
      if (currentMenu.title != null && currentMenu.title !== '') {
        route.meta.title = currentMenu.title;
      }
      if (currentMenu.icon != null && currentMenu.title !== '') {
        route.meta.icon = currentMenu.icon;
      }
      if (currentMenu.sort != null && currentMenu.sort !== '') {
        route.sort = currentMenu.sort;
      }
      route.hidden = currentMenu.hidden;
      return true;
    } else {
      if (route.hidden !== undefined && route.hidden === true) {
        route.sort=-1;
        return true;
      } else {
        return false;
      }
    }
  } else {
    return true;
  }
}

/**
 * 对菜单进行排序
 */
function sortRouters(accessedRouters) {
  for (let i = 0; i < accessedRouters.length; i++) {
    let router = accessedRouters[i];
    if(router.children && router.children.length > 0){
      router.children.sort(compare("sort"));
    }
  }
  accessedRouters.sort(compare("sort"));
}

/**
 * 降序比较函数
 */
function compare(p){
  return function(m,n){
    let a = m[p];
    let b = n[p];
    return a - b;
  }
}

const permission = {
  state: {
    routers: CONSTANT_ROUTER_MAP,
    addRouters: []
  },

  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers;
      state.routers = CONSTANT_ROUTER_MAP.concat(routers);
    }
  },

  actions: {
    GenerateRoutes({ commit }, data) {
      return new Promise(resolve => {
        const { menus } = data;
        const accessedRouters = ASYNC_ROUTER_MAP.filter(item => {
          if (hasPermission(menus, item)) {
            if (item.children && item.children.length > 0) {
              item.children = item.children.filter(child => {
                if (hasPermission(menus, child)) {
                  return child;
                }
                return false;
              });
              return item;
            } else {
              return item;
            }
          }
          return false;
        });
        sortRouters(accessedRouters);
        commit('SET_ROUTERS', accessedRouters);
        resolve();
      })
    }
  }
};

export default permission;



// WEBPACK FOOTER //
// ./src/store/modules/permission.js